export default __webpack_public_path__ + "static/media/screen_livechat_21.cd3eb3ad.png";